// import React from "react";
// import { Swiper, SwiperSlide } from "swiper/react";
// import "swiper/css";

// const PopularDestinations = ({ destinations = [] }) => {
//   return (
//     <section className="popularcontainer">
//       <div className="container">
//         <div className="row">
//           <div
//             className="col-12"
//             data-aos="zoom-in"
//             data-aos-easing="ease-out-cubic"
//             data-aos-duration="1000"
//           >
//             <div className="section-heading">
//               <h2>Popular Destinations</h2>
//             </div>
//           </div>
//         </div>

//         <div className="row">
//           <div className="col-12" data-aos="fade-up" data-aos-duration="500">
//             {destinations.length > 0 ? (
//               <Swiper
//                 spaceBetween={20}
//                 slidesPerView={1}
//                 breakpoints={{
//                   576: { slidesPerView: 2 },
//                   768: { slidesPerView: 3 },
//                   992: { slidesPerView: 4 },
//                 }}
//                 className="swiper"
//                 id="PopularDestination"
//               >
//                 {destinations.map((item) => (
//                   <SwiperSlide key={item.id}>
//                     <div className="populardsbx">
//                       <div className="populardsbximg">
//                         <a href="#">
//                           <img
//                             src={item.destination_image}
//                             alt={item.destination_name}
//                           />
//                         </a>
//                         <div className="bsovrlay">
//                           <a href="#" className="bsview">
//                             <i className="icon icon-search"></i>
//                           </a>
//                         </div>
//                       </div>
//                       <div className="populardsbxct">
//                         <h3>
//                           <a href="#">{item.destination_name}</a>
//                         </h3>
//                       </div>
//                     </div>
//                   </SwiperSlide>
//                 ))}
//               </Swiper>
//             ) : (
//               <p>No destinations available.</p>
//             )}
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default PopularDestinations;

import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import { useNavigate } from "react-router-dom";
import "swiper/css";
import "swiper/css/navigation";
import { formatLocalDate } from "../utils/dateUtils";

const PopularDestinations = ({ destinations = [] }) => {
  const navigate = useNavigate();

  //. Navigate to PropertyList with destination_id
  const handleDestinationClick = (item) => {
    const today = new Date();

    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);

    const dayAfterTomorrow = new Date(today);
    dayAfterTomorrow.setDate(today.getDate() + 2);

    const searchData = {
      destination_id: item.id,
      destination_name: item.destination_name,
      checkin_date: formatLocalDate(tomorrow),
      checkout_date: formatLocalDate(dayAfterTomorrow),
      adults: "1",
      kids: "0",
    };

    // SAME as banner search
    localStorage.setItem("searchParams", JSON.stringify(searchData));

    navigate("/stays", { state: searchData });
  };


  return (
    <section className="popularcontainer">
      <div className="container">
        <div className="row">
          <div
            className="col-12"
            data-aos="zoom-in"
            data-aos-easing="ease-out-cubic"
            data-aos-duration="1000"
          >
            <div className="section-heading">
              <h2>Popular Destinations</h2>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-12" data-aos="fade-up" data-aos-duration="500">
            {destinations.length > 0 ? (
              <>
              <Swiper
                modules={[Navigation, Autoplay]}
                autoplay={{
                  delay: 3000,
                  disableOnInteraction: false,
                }}
                speed={700}
                spaceBetween={15}
                slidesPerView={2.2}
                navigation={{
                  nextEl: ".swiper-button-next-popular-dest",
                  prevEl: ".swiper-button-prev-popular-dest",
                }}
                breakpoints={{
                  100: { slidesPerView: 2.6, spaceBetween: 12 },
                  574: { slidesPerView: 3.4, spaceBetween: 15 },
                  768: { slidesPerView: 4.2, spaceBetween: 15 },
                  992: { slidesPerView: 5, spaceBetween: 18 },
                  1200: { slidesPerView: 6, spaceBetween: 18 },
                  1400: { slidesPerView: 7, spaceBetween: 20 },
                }}
                loop={false}
                className="swiper"
                id="PopularDestination"
              >
                {destinations.map((item) => (
                  <SwiperSlide key={item.id}>
                    <div className="populardsbx">
                      <div className="populardsbximg">
                        <a
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            handleDestinationClick(item);
                          }}
                        >
                          <img
                            src={item.destination_image || "/guestlinkup/images/nli.jpg"}
                            alt={item.destination_name}
                          />
                        </a>
                        <div className="bsovrlay">
                          {/*. Click handler on magnifying glass icon */}
                          <a
                            href="#"
                            className="bsview"
                            onClick={(e) => {
                              e.preventDefault(); // prevent default link
                              handleDestinationClick(item);
                            }}
                          >
                            <i className="icon icon-search"></i>
                          </a>
                        </div>
                      </div>
                      <div className="populardsbxct">
                        <h3>
                          <a href="#" onClick={(e) => {
                            e.preventDefault();
                            handleDestinationClick(item);
                          }}
                          >{item.destination_name}</a>
                        </h3>
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
              <div className="swiper-nav">
                <div className="swiper-button-prev swiper-button-prev-popular-dest"></div>
                <div className="swiper-button-next swiper-button-next-popular-dest"></div>
              </div>
              </>
            ) : (
              <p>No destinations available.</p>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default PopularDestinations;

